export default __webpack_public_path__ + "static/media/a024-1.0f89a9ca.gif";